import React from "react";
import { CheckCircleOutlined } from "@ant-design/icons";

/**
 * A tiny looping demo of what an embedded form actually does: type an
 * email, hit subscribe, see it confirmed. Purely decorative CSS animation
 * (see .form-fill-demo in index.css); prefers-reduced-motion shows the
 * static success frame instead of looping.
 */
export default function FormFillAnimation() {
  return (
    <div className="form-fill-demo" aria-hidden="true">
      <div className="ffd-stage ffd-stage-form">
        <label className="ffd-label mk-mono">Email</label>
        <div className="ffd-input">
          <span className="ffd-input-text">you@company.com</span>
          <span className="ffd-cursor" />
        </div>
        <button type="button" className="ffd-button" tabIndex={-1}>
          Subscribe to Newsletter
        </button>
      </div>
      <div className="ffd-stage ffd-stage-success">
        <CheckCircleOutlined className="ffd-success-icon" />
        <span className="ffd-success-text">You're subscribed!</span>
      </div>
    </div>
  );
}
